import { createStore } from 'zustand'
import { initialVoucherState, type VoucherStore } from '@/scopes/payment/domain/vouchers/types'

export const voucherStore = createVoucherStore()

export function createVoucherStore() {
  return createStore<VoucherStore>(set => ({
    ...initialVoucherState,
    reset: () => set(initialVoucherState),
  }))
}
